export const questions = [
  {
    id: 0,
    question: "How many team members can I invite?",
    respons:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Laborum, sed.",
  },
  {
    id: 1,
    question: "What is the maximum file upload?",
    respons: "No more than 2GB. All files in your account",
  },
  {
    id: 2,
    question: "How do I reset my password?",
    respons:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Laborum, sed.",
  },
  {
    id: 3,
    question: "Can i cancel my subscription?",
    respons:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Laborum, sed.",
  },
  {
    id: 4,
    question: "Do you provide additionnal support?",
    respons:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Laborum, sed.",
  },
];
